import { render, staticRenderFns } from "./announcementDetail.vue?vue&type=template&id=1eae91d9&scoped=true"
import script from "./announcementDetail.vue?vue&type=script&lang=js"
export * from "./announcementDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eae91d9",
  null
  
)

export default component.exports